module.exports = __webpack_public_path__ + "static/media/modal.e64da5d6.sass";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bulma-components/lib/components/modal/modal.sass
// module id = 1287
// module chunks = 0